module.exports = __webpack_public_path__ + "img/antebraco-d.93198da7.png";